/* @flow */

import React from 'react';
import {connect} from 'react-redux';

import LoadingComponent from 'components/loading';
import SupplierContactPersonFormViewComponent from './view';

import CompanyContactPerson from 'models/companies/companyContactPerson';
import SupplierContactPersonForm from './model';

import {handleApiFormResponse, handleFormChange, handleFormValidation} from 'lib/forms';
import loadConstraints from 'lib/validation/loadConstraints';
import ConfirmingService from 'services/ConfirmingService';

type SupplierContactPersonFormComponentProps = {
  activeCompanyId: number;
  supplierCompanyId: number;
  supplierContactPerson: CompanyContactPerson;
  successHandler: (contactPerson: CompanyContactPerson) => void;
  cancelHandler: () => void;
}

type SupplierContactPersonFormComponentState = {
  constraints: any;
  errors: Map<string, ?string>;
  form: SupplierContactPersonForm;
  formErrors: string[];
  isLoading: boolean;
  isProcessing: boolean;
}

class SupplierContactPersonFormComponent extends React.Component<SupplierContactPersonFormComponentProps, SupplierContactPersonFormComponentState> {

  constructor(props) {
    super(props);

    this.state = {
      constraints: null,
      errors: null,
      form: new SupplierContactPersonForm(),
      formErrors: [],
      isLoading: true,
      isProcessing: false
    };
  }

  componentDidMount = async () => {
    const constraints = await loadConstraints('Person', ['lastName', 'firstName', 'email', 'titleId', 'languageId', 'functionName']);
    let form = new SupplierContactPersonForm();
    if (this.props.supplierContactPerson)
        form = new SupplierContactPersonForm(this.props.supplierContactPerson);
    this.setState({
      constraints,
      form,
      errors: new Map(Object.keys(constraints).map(e => [e, undefined])),
      isLoading: false
    });
  };

  handleChange = (fieldName: string) => (event) => handleFormChange.call(this, fieldName, event.target.value);
  handleTypeChange = (fieldName: string) => (id: number) => handleFormChange.call(this, fieldName, id);
  validateForm = () => handleFormValidation.call(this);

  submitForm = async () => {
    if (!this.validateForm()) return;

    try {
      this.setState({formErrors: [], isProcessing: true});
      const request = this.state.form.toRequest(this.props.activeCompanyId, this.props.supplierCompanyId);
      const contactPerson = await ConfirmingService.upsertSupplierContact(request);
      this.props.successHandler(contactPerson);
    } catch (error) {
      handleApiFormResponse.call(this, error);
    }
  };

  render() {
    if (this.state.isLoading) {
      return (<LoadingComponent />);
    }

    return (
      <SupplierContactPersonFormViewComponent
        errors={this.state.errors}
        form={this.state.form}
        formErrors={this.state.formErrors}
        isProcessing={this.state.isProcessing}
        cancel={this.props.cancelHandler}
        handleChange={this.handleChange}
        handleTypeChange={this.handleTypeChange}
        submitForm={this.submitForm}
      />
    );
  }
}


const mapStateToProps = state => ({
  activeCompanyId: state.auth.user.activeCompany.id
});

export default connect(mapStateToProps)(SupplierContactPersonFormComponent);
